import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import DisplaySettings from './DisplaySettings';
interface Props {
    onExit: () => void;
  }
const DisplayModalSettings = ({onExit}:Props) => {
  return (
    <div
      className="modal show"
      style={{ display: "block", position: "absolute",
      background: "rgb(0 0 0 / 0)", margin: "0px -340px", color:'black' }}
    >
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title >
               <span style={{fontSize: "17px"}}> Display settings, changing a value will save it directly</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{maxHeight: "542px", overflow: "auto"}}>
          <DisplaySettings />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={onExit}>
            Close
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  )
}

export default DisplayModalSettings